import React from 'react'

const LegislationPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Legislation Page</h1>
      <p>This is a placeholder for the Legislation page.</p>
    </div>
  )
}

export default LegislationPage